/**
 * Mirror of backend Events365FeeMode — keep string values in sync with
 * sky360-ms/tsx/ts-events365/src/enum/events365-fee-mode.enum.ts
 */
export enum Events365FeeMode {
  PASS_THROUGH = 'pass_through',
  COMMISSIONED = 'commissioned',
}

export const DEFAULT_EVENTS365_FEE_MODE = Events365FeeMode.PASS_THROUGH;

export interface Events365CartLinePricingInput {
  grossPricePerTicket: number;
  quantity: number;
  deliveryPrice?: number;
  serviceFee?: number;
  feeMode?: Events365FeeMode;
  /**
   * Required when feeMode is COMMISSIONED.
   * Pre-computed line gross from backend (search/refresh) until client-side
   * commission stack is shared.
   */
  commissionedLineGross?: number;
}

/**
 * B2C cart line total for Events365 tickets.
 * Default PASS_THROUGH matches ShoppingCartSliceV2 behaviour today.
 */
export function calculateEvents365CartLineTotal({
  grossPricePerTicket,
  quantity,
  deliveryPrice = 0,
  serviceFee = 0,
  feeMode = DEFAULT_EVENTS365_FEE_MODE,
  commissionedLineGross,
}: Events365CartLinePricingInput): number {
  switch (feeMode) {
    case Events365FeeMode.PASS_THROUGH:
      return (
        grossPricePerTicket * quantity + deliveryPrice + serviceFee
      );

    case Events365FeeMode.COMMISSIONED:
      if (commissionedLineGross === undefined) {
        throw new Error(
          'commissionedLineGross is required when feeMode is COMMISSIONED',
        );
      }
      return commissionedLineGross;

    default: {
      const _exhaustive: never = feeMode;
      throw new Error(`Unsupported Events365 fee mode: ${_exhaustive}`);
    }
  }
}
